import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

function TextUnderline({ children }:Props) {
    return (
        <Component>
            {children}
        </Component>
    );
}

const Component = styled.div`
    max-width: 100%;
    position: relative;

    &::after {
        background-color: var(--color-primary-opacity-30);
        border-radius: var(--radius-xs);
        content: '';
        height: 10px;
        left: 0;
        position: absolute;
        width: 100%;
        padding: 0 var(--spacing-0-5);
        bottom: 0;
    }
`;

export default TextUnderline;
